export class HeaderItem {
  title: String | undefined;
  type: String | undefined;
  value: String | undefined;
}
export class NotesItem {
  title: String | undefined;
  type: String | undefined;
  value: String | undefined;
}
export class signotoriesItem {
  title: String | undefined;
  fullNameRequired: Boolean | undefined;
  type: String | undefined;
  who: String | undefined;
  value: String | undefined;
}
export class inspectionsItem {
  title: String | undefined;
  questions: [Question] | undefined;
}
export class Question {
  _id: String | undefined;
  question: String | undefined;
  index: Number | undefined;
  legend: String | undefined;
  edit: Boolean | undefined;
  value: String | undefined;
}
export class InspectionModel {
  name: String | undefined;
  frequency: String | undefined;
  inspectionType: String | undefined;
  companyId: String | undefined;
  headerItems: [HeaderItem] | undefined;
  notesItems: [NotesItem] | undefined;
  signotoriesItems: [signotoriesItem] | undefined;
  inspectionsItems: [inspectionsItem] | undefined;
}
export class AssignTo {
  fullName: String | undefined;
  position: String | undefined;
  id: String | undefined;
  signedOn: Date | undefined;
  submitedOn: Date | undefined;
}
export class Assign {
  assignedTo: AssignTo | undefined;
  assignmentDate: Date | undefined;
  completionDate: Date | undefined;
  status: String | undefined;
}
export class ActionInspectionModel {
  _id: String | undefined;
  assign: Assign | undefined;
  companyId: String | undefined;
  inspection: InspectionModel | undefined;
  history: [AssignTo] | undefined;
}
